<svg
  class="block size-full"
  [attr.width]="width ?? size"
  [attr.height]="height ?? size"
  fill="none"
  preserveAspectRatio="none"
  viewBox="0 0 20 20"
>
  <path
    d="M10 16.6667V3.33333M10 3.33333L5 8.33333M10 3.33333L15 8.33333"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2.22222"
  ></path>
</svg>
